/** Appointment clock time from OPM when present; otherwise recommendation surgery date. */
export function patientSurgeryDate(patient) {
  return patient?.surgery_start_time || patient?.surgery?.date || null;
}
